import { TabsButtonGroupHeaderProps } from 'Types/Presentation/Components/Tabs/ButtonGroup'
import clsx from 'clsx'

const TabHeader: React.FC<TabsButtonGroupHeaderProps> = ({
	tabNames,
	activeTab,
	handleTabClick,
}) => {
	return (
		<div
			className="tabs-button-group-container"
			style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
			{tabNames.map((tabName, idx) => (
				<button
					key={`tab-button-group-header-item-${idx}`}
					className={clsx('btn btn-sm fw-bold', {
						'white-button': activeTab === idx,
						'bg-transparent border-0 text-kumopack-grey-500': activeTab !== idx,
					})}
					onClick={() => handleTabClick(idx)}>
					{tabName}
				</button>
			))}
		</div>
	)
}

export default TabHeader
